<template>
  <div
    id="menuToggle"
    :class="['menu-toggle', {active: menuStore.isOpen}]"
    @click="menuStore.toggleMenu"
  >
    <div class="bar1"></div>
    <div class="bar2"></div>
    <div class="bar3"></div>
  </div>
</template>

<script setup>
import useMenuStore from '@/store/modules/menu.js';

const menuStore = useMenuStore();
</script>
